import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocationProperty } from "wouter/use-location";

import { getURL } from "../../util/getURL";
import { urlSlice } from "../slices/urlSlice";

export const useUrlSync = (): void => {
  const url = useLocationProperty(getURL);
  const dispatch = useDispatch();
  useEffect(() => {
    const action = urlSlice.actions.next(url);
    dispatch(action);
  }, [url]);
};
